import { NotificationsActions } from '@microsoft/portal-app/lib/Notifications/models';
import { IDialogState } from '@microsoft/portal-app/lib/Notifications/models/IDialogState';
import { createAction } from '@microsoft/portal-app/lib/redux/createAction';
import { UserActions } from '@microsoft/portal-app/lib/User/models';
import { translate } from 'react-i18next';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouterAction } from 'connected-react-router';
import { AccountActions, IRootAccountState } from '../models';
import { PersonBadge } from './PersonBadge';
import { IConnectedPersonBadgeProps, IPersonBadgeActions, IPersonBadgeMappedProps } from './PersonBadge.types';

/**
 * Maps the external (i.e. own) props and the state to the properties of the PersonBadge control.
 * @param state The current redux state to map to props
 * @param ownProps The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (IPersonBadgeProps) for the PersonBadge control
 */
const mapStateToProps = (state: IRootAccountState, _ownProps: IConnectedPersonBadgeProps): IPersonBadgeMappedProps => {
  const { auth } = state.user;
  const { currentUser } = state.account;

  return {
    user: (auth && auth.userName) || '',
    userProfile: auth && auth.profile,
    userPerson: currentUser,
  };
};

/**
 * Maps the dispatch actions to the props for the PersonBadge control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (IPersonBadgeProps) for the PersonBadge control
 */
const mapDispatchToProps = (dispatch: Dispatch<IRootAccountState>): IPersonBadgeActions => {
  return {
    getUser: () => {
      dispatch({ type: AccountActions.getUser });
    },
    showDialog: createAction<IDialogState>(NotificationsActions.showDialog, dispatch),
    dispatchRouterAction: (routerAction: RouterAction) => {
      dispatch(routerAction);
    },
  };
};

/**
 * A redux connected PersonBadge control.
 * @description Supports translation
 */
export const ConnectedPersonBadge = connect(mapStateToProps, mapDispatchToProps)(translate('Account')(PersonBadge));
